<app-header></app-header>
<app-hero-banner
  [city]="city"
  [tags]="tags"
  (onCityChange)="cityChanged($event)"
  (onTagsChange)="tagsChanged($event)"
></app-hero-banner>
<app-photographer-list
  [city]="city"
  [tags]="tags"
></app-photographer-list>
<app-footer></app-footer>
